import React, { JSX, useCallback, useEffect, useState } from 'react'
import i18n from 'live/services/i18n'
import Select from 'live/components/forms/ui/select'
import { SelectWrapper } from '../styles/ChannelStyle'
import { KPISDrillingRegistryContextType } from '../../types/kpis-drilling/kpis-drilling-registry-type'
import { getActiveOption, rigFloorMethodologyOptions } from '../common'
import { SelectOptionsPreset } from '../../types'

export const ReprocessRigFloorSelectMethodoly = (props: KPISDrillingRegistryContextType): JSX.Element => {
    const { contextState } = props
    const { hasPermissionToEdit } = contextState?.reprocess?.props || {}
    const { isReprocessingData, isRigFloorWaiting } = contextState?.reprocess?.rigfloor || {}

    const [selectedMethodology, setSelectedMethodology] = useState<SelectOptionsPreset>(
        getActiveOption(rigFloorMethodologyOptions)
    )

    const handleMethodologyChange = useCallback(
        (el: string, ind: SelectOptionsPreset): void => {
            setSelectedMethodology(ind)
            props?.setContextState(prevState => ({
                ...prevState,
                reprocess: {
                    ...prevState?.reprocess,
                    // creating rigfloor if is not exist
                    rigfloor: {
                        ...prevState?.reprocess?.rigfloor,
                        selectedMethodology: ind,
                        setSelectedMethodology
                    }
                }
            }))
        },
        [props]
    )

    useEffect(() => {
        props?.setContextState(prevState => ({
            ...prevState,
            reprocess: {
                ...prevState?.reprocess,
                // creating rigfloor if is not exist
                rigfloor: {
                    ...prevState?.reprocess?.rigfloor,
                    setSelectedMethodology
                }
            }
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SelectWrapper>
            <Select
                style={{ minWidth: '200px', maxHeight: '50px' }}
                disabled={isReprocessingData || !hasPermissionToEdit || isRigFloorWaiting}
                clearable={false}
                searchable={false}
                options={rigFloorMethodologyOptions}
                value={i18n(selectedMethodology?.value)}
                onChange={handleMethodologyChange}
                placeholder={i18n(selectedMethodology?.label)}
            />
        </SelectWrapper>
    )
}
